import { render } from "./XIconSolidGoogleLogo.vue?vue&type=template&id=850c0c48"
import script from "./XIconSolidGoogleLogo.vue?vue&type=script&lang=js"
export * from "./XIconSolidGoogleLogo.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/mohovers/dev/dev-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidGoogleLogo.vue"]])

export default __exports__